import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Empty.scss';

class Empty extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      navigation_name: PropTypes.string,
      slices: PropTypes.array,
    }).isRequired,
  };

  render() {
    const { content } = this.props;
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>{content.navigation_name}</h1>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Empty);
